// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c78b9c28","239":"30f30dca","453":"44b8ec0e","455":"88fc017c"}[chunkId] + ".chunk.js";
};